import type { ReactNode } from "react";

// noop
export const SafeAreaProvider = ({
  children
}: {
  children: ReactNode;
}) => <>{children}</>;